import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { getPlaybookPage } from "@/lib/playbook-content";
import { Markdown } from "@/components/kb/markdown";

export const Route = createFileRoute("/_authenticated/app/playbook/$")({
  component: PlaybookPageView,
  notFoundComponent: () => (
    <div className="p-6 text-sm text-muted-foreground">
      Page not found. <Link to="/app/playbook" className="text-primary underline">Back to the Playbook</Link>.
    </div>
  ),
  loader: ({ params }) => {
    const page = getPlaybookPage((params as { _splat?: string })._splat ?? "");
    if (!page) throw notFound();
    return { page };
  },
});

function PlaybookPageView() {
  const { page } = Route.useLoaderData();
  const fm = page.frontmatter;

  return (
    <article className="p-4 sm:p-8 max-w-3xl mx-auto space-y-4">
      {(fm.status === "planned" || fm.status === "code-complete") && (
        <div className={`text-xs rounded-md border px-3 py-2 ${fm.status === "planned" ? "bg-muted" : "bg-amber-100/40 dark:bg-amber-900/20 border-amber-300/50"}`}>
          {fm.status === "planned"
            ? "Status: planned. This capability is not yet available to operators."
            : "Status: code-complete. Implemented but not yet wired into the operator experience."}
        </div>
      )}
      <div className="text-[11px] text-muted-foreground flex items-center gap-3">
        {fm.last_verified && <span>Last verified {fm.last_verified}</span>}
        {typeof fm.last_verified_sprint === "number" && <span>· Sprint {fm.last_verified_sprint}</span>}
        {fm.status && <span>· {fm.status}</span>}
      </div>
      <Markdown source={page.body} />
      {Array.isArray(fm.related) && fm.related.length > 0 && (
        <footer className="pt-4 border-t text-sm">
          <div className="text-xs uppercase text-muted-foreground mb-1">Related</div>
          <div className="flex flex-wrap gap-2">
            {fm.related.map((slug: string) => (
              <Link
                key={slug}
                to="/app/playbook/$"
                params={{ _splat: `capabilities/${slug}` }}
                className="text-primary hover:underline"
              >
                {slug}
              </Link>
            ))}
          </div>
        </footer>
      )}
    </article>
  );
}